export const CONFIG = {
    apiUrl: 'https://api-leadrs-co.osc-fr1.scalingo.io',
    //apiUrl: 'http://localhost:8080',
};
